// extracted by mini-css-extract-plugin
export default {"root":"classes_root__O3FOl","link":"classes_link__kbn3a"};